// import feeService from 'ApiService/Accountant/feeService';
// import courseService from 'ApiService/Admin/courseService';
// import adminFeeService from 'ApiService/Admin/feeService';
// import Card from 'components/card';
// import { AuthContext } from 'contexts/AuthContext';
// import { useContext, useEffect, useState } from 'react';
// import toast from 'react-hot-toast';
// import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';
// import SelectClass from '../PayFees/Steps/StepOne';
// import StudentFeeDetails from './StudentFeeDetails';
// const Index = () => {
//   const [currentStep, setCurrentStep] = useState(1);
//   const [classData, setClassData] = useState({
//     courseId: '',
//     batchId: '',
//   });
//   const [selectedStudent, setSelectedStudent] = useState(null);
//   const [students, setStudents] = useState([]);
//   const [disable, setDisable] = useState(true);
//   const [loading, setLoading] = useState(false);
//   const [courses, setCourses] = useState([]);
//   const { state } = useContext(AuthContext);
//   const [loadingCourses, setLoadingCourses] = useState(true);
//   const [loadingStudent, setLoadingStudent] = useState(true);
//   const selectedBranch = state?.selectedBranch || '';

//   const fetchCourses = async () => {
//     setLoadingCourses(true);
//     try {
//       let response;
//       if (state.user.role === 'account') {
//         response = await feeService.getCourseBatchInfo();
//       } else {
//         response = await courseService.getCourseBatchInfo(selectedBranch);
//       }
//       if (response.data.success) {
//         setCourses(response.data.courses || []);
//       } else {
//         toast.error('Failed to fetch courses.');
//         setCourses([]);
//       }
//     } catch (error) {
//       toast.error(error?.response?.data?.message || 'Failed to fetch courses.');
//       setCourses([]);
//     } finally {
//       setLoadingCourses(false);
//     }
//   };

//   useEffect(() => {
//     fetchCourses();
//   }, [selectedBranch]);

//   const fetchStudents = async () => {
//     try {
//       setLoadingStudent(true);
//       let response = {};
//       if (state.user.role === 'account' || state.user.role === 'superadmin') {
//         response = await feeService.getStudentDetails(
//           classData,
//           selectedBranch
//         );
//       } else {
//         response = await adminFeeService.getStudentDetails(classData);
//       }
//       if (response.data.success) {
//         setStudents(response.data.data);
//       } else {
//         toast.error('Failed to fetch students.');
//       }
//     } catch (error) {
//       toast.error(
//         error?.response?.data?.message || 'Failed to fetch students.'
//       );
//     } finally {
//       setLoadingStudent(false);
//     }
//   };

//   const handleNext = async () => {
//     if (currentStep === 1) {
//       await fetchStudents();
//       setCurrentStep(2);
//     }
//   };

//   const handleBack = () => {
//     setCurrentStep(1);
//     setSelectedStudent(null);
//   };
//   const clearData = () => {
//     setStudents([]);
//   };
//   const displayStep = (step) => {
//     switch (step) {
//       case 1:
//         return (
//           <SelectClass
//             setDisable={setDisable}
//             setClassData={setClassData}
//             classData={classData}
//             courses={courses}
//             loadingCourses={loadingCourses}
//             clearData={clearData}
//           />
//         );
//       case 2:
//         return (
//           <StudentFeeDetails
//             students={students}
//             selectedStudent={selectedStudent}
//             setSelectedStudent={setSelectedStudent}
//             classData={classData}
//             loadingStudent={loadingStudent}
//           />
//         );
//       default:
//         return null;
//     }
//   };

//   return (
//     <div className="mt-3 h-full w-full">
//       <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />
//       <div className="mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
//         <Card
//           extra={
//             '-mt-[280px] w-full md:-mt-[340px] md:px-[70px] h-full mx-auto pb-3'
//           }
//         >
//           <div className="w-full rounded-[20px]">
//             <UseContextProvider>{displayStep(currentStep)}</UseContextProvider>
//           </div>
//           <div className="flex flex-col justify-end px-3 pt-2 md:flex-row md:px-8">
//             {currentStep === 2 && (
//               <button
//                 onClick={handleBack}
//                 className="linear mb-2 cursor-pointer rounded-xl bg-gray-100 px-16 py-2 font-medium text-gray-900 transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-navy-700 dark:text-white dark:hover:bg-navy-600 dark:active:bg-navy-500 md:mb-0 md:mr-2"
//               >
//                 Back
//               </button>
//             )}
//             {currentStep === 1 && (
//               <button
//                 disabled={disable || loading}
//                 onClick={handleNext}
//                 className="linear cursor-pointer rounded-xl bg-brand-900 px-16 py-2 font-medium text-white transition duration-200 hover:bg-brand-800 active:bg-brand-700 dark:bg-brand-400 dark:hover:bg-brand-300 dark:active:opacity-90 md:ml-2"
//               >
//                 {loading ? 'Loading...' : 'Next'}
//               </button>
//             )}
//           </div>
//         </Card>
//       </div>
//     </div>
//   );
// };

// export default Index;
import feeService from 'ApiService/Accountant/feeService';
import courseService from 'ApiService/Admin/courseService';
import batchService from 'ApiService/Admin/batchService';

import Card from 'components/card';
import { AuthContext } from 'contexts/AuthContext';
import { useContext, useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { UseContextProvider } from 'views/admin/main/users/newUser/contexts/StepperContext';

import SelectClass from '../PayFees/Steps/StepOne';
import StudentFeeDetails from './StudentFeeDetails';

const Index = () => {
  /* ================= STEP ================= */
  const [currentStep, setCurrentStep] = useState(1);

  /* ================= CLASS DATA ================= */
  const [classData, setClassData] = useState({
    courseId: '',
    batchStructureId: '',
    batchId: '',
  });

  /* ================= DATA ================= */
  const [courses, setCourses] = useState([]);
  const [batchStructures, setBatchStructures] = useState([]);
  const [students, setStudents] = useState([]);

  /* ================= UI ================= */
  const [selectedStudent, setSelectedStudent] = useState(null);
  const [disable, setDisable] = useState(true);
  const [loadingCourses, setLoadingCourses] = useState(false);
  const [loadingStudent, setLoadingStudent] = useState(false);

  /* ================= AUTH ================= */
  const { state, loading } = useContext(AuthContext);

  const user = state?.user;
  const role = user?.role;
  const isSuperAdmin = role === 'superadmin';

  const selectedBranch = isSuperAdmin
    ? state?.selectedBranch
    : user?.branch?._id;

  /* ================= RESET STEP ONE ================= */
  const resetStepOne = () => {
    setClassData({
      courseId: '',
      batchStructureId: '',
      batchId: '',
    });
    setBatchStructures([]);
    setStudents([]);
    setSelectedStudent(null);
    setDisable(true);
  };

  /* ================= RESET ONLY WHEN SUPERADMIN CHANGES BRANCH ================= */
  useEffect(() => {
    if (!isSuperAdmin) return;
    if (!selectedBranch) return;

    resetStepOne();
  }, [isSuperAdmin, selectedBranch]);

  /* ================= FETCH COURSES ================= */
  const fetchCourses = async () => {
    setLoadingCourses(true);
    try {
      if (state.user.role === 'account') {
        const res = await feeService.getAllCourses(selectedBranch);
        setCourses(res?.data?.courses || []);
      } else {
        const res = await courseService.getAllCourses(selectedBranch);
        setCourses(res?.data?.courses || []);
      }
    } catch {
      toast.error('Failed to fetch courses');
      setCourses([]);
    } finally {
      setLoadingCourses(false);
    }
  };

  /* ================= FETCH COURSES (ADMIN + SUPERADMIN SAFE) ================= */
  useEffect(() => {
    if (loading) return;
    if (!user) return;

    if (isSuperAdmin && !selectedBranch) return;

    fetchCourses();
  }, [loading, user, isSuperAdmin, selectedBranch]);

  /* ================= FETCH STRUCTURES ================= */
  const fetchBatchStructures = async (courseId) => {
    try {
      if (state.user.role === 'account') {
        const res = await feeService.getBatchStructuresByCourse(
          courseId,
          selectedBranch
        );
        setBatchStructures(res?.data?.batchStructures || []);
      } else {
        const res = await batchService.getBatchStructuresByCourse(
          courseId,
          selectedBranch
        );
        setBatchStructures(res?.data?.batchStructures || []);
      }
    } catch {
      toast.error('Failed to fetch batch structures');
      setBatchStructures([]);
    }
  };

  /* ================= FETCH BATCHES ================= */
  const fetchBatchesByStructure = async (structureId) => {
    try {
      if (state.user.role === 'account') {
        const res = await feeService.getBatchesByBatchStructure(
          structureId,
          selectedBranch
        );
        return res?.data?.batches || [];
      } else {
        const res = await batchService.getBatchesByBatchStructure(
          structureId,
          selectedBranch
        );
        return res?.data?.batches || [];
      }
    } catch {
      toast.error('Failed to fetch batches');
      return [];
    }
  };

  /* ================= FETCH STUDENTS ================= */
  const fetchStudents = async () => {
    try {
      setLoadingStudent(true);
      const res = await feeService.getStudentDetails(classData, selectedBranch);
      setStudents(res?.data?.data || []);
    } catch {
      toast.error('Failed to fetch students');
    } finally {
      setLoadingStudent(false);
    }
  };

  /* ================= STEP HANDLERS ================= */
  const handleNext = async () => {
    if (currentStep === 1) {
      await fetchStudents();
      setCurrentStep(2);
    }
  };

  const handleBack = () => {
    resetStepOne();
    setCurrentStep(1);
  };

  const clearData = () => {
    setStudents([]);
  };

  /* ================= STEP RENDER ================= */
  const displayStep = (step) => {
    switch (step) {
      case 1:
        return (
          <SelectClass
            setDisable={setDisable}
            classData={classData}
            setClassData={setClassData}
            courses={courses}
            loadingCourses={loadingCourses}
            batchStructures={batchStructures}
            fetchBatchStructures={fetchBatchStructures}
            fetchBatchesByStructure={fetchBatchesByStructure}
            selectedBranch={selectedBranch}
            clearData={clearData}
          />
        );

      case 2:
        return (
          <StudentFeeDetails
            students={students}
            selectedStudent={selectedStudent}
            setSelectedStudent={setSelectedStudent}
            classData={classData}
            loadingStudent={loadingStudent}
          />
        );

      default:
        return null;
    }
  };

  /* ================= LOADERS ================= */
  if (loading) {
    return (
      <div className="flex h-60 items-center justify-center">
        Loading user...
      </div>
    );
  }

  if (isSuperAdmin && !selectedBranch) {
    return (
      <div className="flex h-60 items-center justify-center">
        Please select a branch
      </div>
    );
  }

  return (
    <div className="mt-3 h-full w-full">
      <div className="h-[350px] w-full rounded-[20px] bg-gradient-to-br from-brand-400 to-brand-600 md:h-[390px]" />

      <div className="mx-auto h-full w-5/6 md:px-3 3xl:w-7/12">
        <Card extra="-mt-[280px] w-full md:-mt-[340px] md:px-[70px] pb-3">
          <UseContextProvider>{displayStep(currentStep)}</UseContextProvider>

          <div className="flex justify-end px-3 pt-4">
            {currentStep === 2 && (
              <button
                onClick={handleBack}
                className="mr-3 rounded-xl bg-gray-200 px-14 py-2"
              >
                Back
              </button>
            )}

            {currentStep === 1 && (
              <button
                disabled={disable}
                onClick={handleNext}
                className="rounded-xl bg-brand-900 px-16 py-2 text-white disabled:opacity-60"
              >
                Next
              </button>
            )}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Index;
